import { render, staticRenderFns } from "./ResumeDetail.vue?vue&type=template&id=13d6ddc4&scoped=true&"
import script from "./ResumeDetail.vue?vue&type=script&lang=js&"
export * from "./ResumeDetail.vue?vue&type=script&lang=js&"
import style0 from "./ResumeDetail.vue?vue&type=style&index=0&id=13d6ddc4&lang=less&scoped=true&"
import style1 from "./ResumeDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d6ddc4",
  null
  
)

export default component.exports